import { useEffect, useMemo, useState } from "react";
import useWindowDimensions from "../../../../../hooks/useWindowDimension";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { Modal } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import Stories from "react-insta-stories";
import { eAssetType } from "asset-analysis/lib/@types/config/asset.enum";
import GetStoriesNews from "../../../../StoriesNewsData";
import useStories from "../../../../../hooks/useStories";

type NewsItem = {
  name: string;
  content: string;
  date: string;
  dateTimestamp: number;
  dataID: any;
  providerID: string;
  providerName: string;
  image: string;
  linkExternal: string;
  newsId: number;
  isSeen: boolean;
};

type Props = {
  profilePictureSrc: string;
  newsData: NewsItem[];
  assetType: eAssetType;
  assetName: string;
};
export default function ProfilePictureStories({
  profilePictureSrc,
  newsData: newsRawData,
  assetType,
  assetName,
}: Props) {
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [isAllViewed, setIsAllViewed] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [startFrom, setStartFrom] = useState<number>(0);
  const { width } = useWindowDimensions();
  const [newsLocalState, setNewsLocalState] = useState<NewsItem[]>(newsRawData);
  const [pendingPersistViewed, setPendingPersistViewed] = useState<number[]>(
    [] as number[]
  );
  const [lastSeenStoryIndex, setLastSeenStoryIndex] = useState<number>(0);

  const { markViewedMany } = useStories();

  const stories = useMemo(() => {
    if (newsRawData) {
      return GetStoriesNews({
        newsData: newsRawData,
        assetType,
        icon: profilePictureSrc,
        assetName,
      });
    }
  }, [newsRawData, assetType, profilePictureSrc, assetName]);

  useEffect(() => {
    if (newsRawData && stories) {
      if (newsRawData.length > 0) {
        setShowLoader(true);
      }
      const onlyVisibleNews = newsLocalState
        .map((newsItem) => {
          const storyItem = stories.find(
            (item: any) => item.newsItem.newsId === newsItem.newsId
          );

          if (storyItem) {
            return newsItem;
          }

          return null;
        })
        .filter((item) => item);

      const everyViewed = onlyVisibleNews.every((item: any) => item.isSeen);
      setIsAllViewed(everyViewed);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newsLocalState]);

  async function handleModalOpen() {
    setShowModal(true);

    let i = 0;
    for (const story of stories) {
      const newsItem = newsLocalState.find(
        (item) => item.newsId === story.newsItem.newsId
      );

      if (newsItem) {
        const isSeen = newsItem.isSeen;

        if (!isSeen) {
          setStartFrom(i);
          break;
        }
      }

      i++;
    }

    if (isAllViewed) {
      setStartFrom(0);
    }
  }

  async function handleModalClose() {
    setShowModal(false);
    const isPenultStory = lastSeenStoryIndex + 2 === stories.length;

    if (isPenultStory) {
      return markAllNewsAsSeen();
    }

    if (pendingPersistViewed.length > 0) {
      markViewedMany(pendingPersistViewed);
    }

    setPendingPersistViewed([]);
  }

  function handleStoryView(item: any) {
    const storyNewsId = item.newsItem.newsId;
    const storyIndex = stories.findIndex(
      (story: any) => story.newsItem.newsId === storyNewsId
    );
    setLastSeenStoryIndex(storyIndex);

    const newNewsState = newsLocalState.map((news) => {
      if (news.newsId === storyNewsId) {
        if (!news.isSeen) {
          setPendingPersistViewed([...pendingPersistViewed, news.newsId]);
        }
        news.isSeen = true;
      }

      return news;
    });

    setNewsLocalState(newNewsState);
  }

  function markAllNewsAsSeen() {
    const newsIds = newsLocalState.map((news) => news.newsId);
    setNewsLocalState(
      newsLocalState.map((news) => {
        news.isSeen = true;

        return news;
      })
    );

    return markViewedMany(newsIds);
  }

  return (
    <div
      className="insta-circle-img"
      style={width >= 768 ? { bottom: 60 } : { bottom: 0 }}
    >
      <img
        onClick={() => {
          handleModalOpen();
        }}
        style={showLoader ? { cursor: "pointer" } : {}}
        src={profilePictureSrc}
        alt="asset"
      />
      {
        //Show loading color in stories.
        showLoader ? (
          <svg
            style={isAllViewed ? { stroke: "#9e9e9e", animation: "none" } : {}}
            viewBox="0 0 100 100"
            xmlnsXlink="http://www.w3.org/2000/svg"
          >
            <circle cx="50" cy="50" r="40" />
          </svg>
        ) : null
      }

      {stories ? (
        <Modal
          show={showModal}
          onHide={() => handleModalClose()}
          keyboard={true}
        >
          {isMobile ? (
            //Add the close button in mobile.
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                backgroundColor: "#424242",
              }}
            >
              <AiOutlineCloseCircle
                color="white"
                size={20}
                onClick={() => {
                  return handleModalClose();
                }}
              />
            </div>
          ) : null}
          <Stories
            stories={stories}
            width={"100%"}
            storyContainerStyles={{
              background: "black",
            }}
            keyboardNavigation={false}
            height={"95vh"}
            currentIndex={startFrom}
            onStoryStart={(i: number, item: any) => handleStoryView(item)}
            onStoryEnd={(i: number, item: any) => handleStoryView(item)}
            onAllStoriesEnd={() => {
              markAllNewsAsSeen();

              return setShowModal(false);
            }}
          />
        </Modal>
      ) : null}
    </div>
  );
}
